"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrencySymbol = exports.numberToMoney = exports.getKeyValue = exports.numericToAlpha = exports.numbersToWords = exports.booleanToYesNo = exports.generateNumberUuid = exports.generateShortUuid = exports.removeTimeZone = exports.secondsToTime = exports.timeToSeconds = exports.timeToFormattedString = exports.dateToFormattedString = exports.pluralise = exports.numbersOnly = exports.stringFromArray = exports.wordsToAcronym = exports.camelToSpaces = exports.camelToCapital = exports.sentenceCase = exports.capitaliseFirstOnly = exports.capitaliseFirst = void 0;
const capitaliseFirst = (value) => {
    const words = value === null || value === void 0 ? void 0 : value.toLowerCase().split(' ');
    return words.map((i) => (i ? `${i[0].toUpperCase()}${i.slice(1)}` : '')).join(' ');
};
exports.capitaliseFirst = capitaliseFirst;
const capitaliseFirstOnly = (value) => {
    const words = value.split('. ');
    return words.map((i) => (i ? `${i[0].toUpperCase()}${i.slice(1)}` : '')).join('. ');
};
exports.capitaliseFirstOnly = capitaliseFirstOnly;
const sentenceCase = (value) => {
    const words = value === null || value === void 0 ? void 0 : value.toLowerCase().split('. ');
    return words.map((i) => (i ? `${i[0].toUpperCase()}${i.slice(1)}` : '')).join('. ');
};
exports.sentenceCase = sentenceCase;
const camelToCapital = (value) => {
    const words = value === null || value === void 0 ? void 0 : value.replace(/([A-Z])/g, ',$1').replace(/^,/, '').split(',');
    return words.map((i) => `${i[0].toUpperCase()}${i.slice(1)}`).join(' ');
};
exports.camelToCapital = camelToCapital;
const camelToSpaces = (value) => {
    return value === null || value === void 0 ? void 0 : value.replace(/([A-Z])/g, ',$1').replace(/^,/, '').split(',').join(' ');
};
exports.camelToSpaces = camelToSpaces;
const wordsToAcronym = (value) => {
    const words = value ? value.split(' ') : [];
    return words.map((i) => i[0].toUpperCase()).join('');
};
exports.wordsToAcronym = wordsToAcronym;
const stringFromArray = (words, divider = ' ') => {
    return words.join(divider);
};
exports.stringFromArray = stringFromArray;
const numbersOnly = (value) => {
    return value === null || value === void 0 ? void 0 : value.replace(/(\D+)/g, '');
};
exports.numbersOnly = numbersOnly;
const pluralise = (value, length) => {
    let plu = 's';
    if (value.constructor.name === 'Array') {
        return length === 1 ? value[0] : value[1];
    }
    let v = value;
    if (v.endsWith('h')) {
        plu = 'es';
    }
    if (v.endsWith('y')) {
        if (length !== 1) {
            plu = 'ies';
            v = v.slice(0, -1);
        }
    }
    return `${v}${length === 1 ? '' : plu}`;
};
exports.pluralise = pluralise;
const dateToFormattedString = (value) => {
    const d = new Date(value);
    return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
};
exports.dateToFormattedString = dateToFormattedString;
const timeToFormattedString = (value, format, noTimeZone = false) => {
    if (value) {
        let sp = 0;
        switch (format) {
            case 'H':
                sp = 1;
                break;
            case 'HM':
                sp = 2;
                break;
            case 'HMS':
                sp = 3;
                break;
            case 'HMSM':
                sp = 4;
                break;
            default:
                break;
        }
        const time = value.replace('.', ':').split(':').slice(0, sp).join(':');
        return noTimeZone ? (0, exports.removeTimeZone)(time) : time;
    }
    return value;
};
exports.timeToFormattedString = timeToFormattedString;
const timeToSeconds = (time) => {
    const [h, m, s] = time.split(':');
    return +h * 60 * 60 + +m * 60 + +s;
};
exports.timeToSeconds = timeToSeconds;
const secondsToTime = (seconds) => {
    return new Date(seconds * 1000).toISOString().split('T')[1].slice(0, -1).split('.')[0];
};
exports.secondsToTime = secondsToTime;
const removeTimeZone = (value) => {
    return value.split('+')[0];
};
exports.removeTimeZone = removeTimeZone;
const generateShortUuid = () => {
    return Math.random().toString(36).slice(-6);
};
exports.generateShortUuid = generateShortUuid;
const generateNumberUuid = (length) => {
    return Math.floor(Math.pow(10, length - 1) + Math.random() * (Math.pow(10, length) - Math.pow(10, length - 1) - 1));
};
exports.generateNumberUuid = generateNumberUuid;
const booleanToYesNo = (value) => {
    return value ? 'Yes' : 'No';
};
exports.booleanToYesNo = booleanToYesNo;
const numbersToWords = (limit) => {
    const n = [
        'First',
        'Second',
        'Third',
        'Fourth',
        'Fifth',
        'Sixth',
        'Seventh',
        'Eighth',
        'Nineth',
        'Tenth',
        'Eleventh',
        'Twelveth',
        'Thirteenth',
        'Fourteenth',
        'Fifteenth',
        'Sixteenth',
        'Seventeenth',
        'Eighteenth',
        'Nineteenth',
        'Twentieth',
    ];
    return n.slice(0, limit);
};
exports.numbersToWords = numbersToWords;
const numericToAlpha = (num) => {
    let s = '';
    let t;
    while (num > 0) {
        t = (num - 1) % 26;
        s = String.fromCharCode(65 + t) + s;
        num = ((num - t) / 26) | 0;
    }
    return s;
};
exports.numericToAlpha = numericToAlpha;
const getKeyValue = (obj, key, booleanAsString = false) => {
    const nesting = key.split('.');
    if (nesting.length > 1) {
        return (0, exports.getKeyValue)(obj[nesting[0]], nesting.slice(1).join('.'));
    }
    if (booleanAsString && (obj[key] === true || obj[key] === false)) {
        return (0, exports.booleanToYesNo)(obj[key]);
    }
    return obj[key];
};
exports.getKeyValue = getKeyValue;
const numberToMoney = (value, currency, locale, isPennies = false) => {
    if (!currency || !locale) {
        return '';
    }
    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
    });
    return formatter.format(isPennies ? value / 100 : value);
};
exports.numberToMoney = numberToMoney;
const getCurrencySymbol = (currency, locale) => {
    if (!currency || !locale) {
        return '';
    }
    const m = (0, exports.numberToMoney)(0, currency, locale);
    return m.replace(/\d./g, '').trim();
};
exports.getCurrencySymbol = getCurrencySymbol;
//# sourceMappingURL=stringUtils.js.map